export const ROUTES = {
  COMPLIANCE_SUBSCRIPTION: "/abonament-na-zgodnosc/",

  // Elektryczne
  ELECTRICAL_CHECK: "/przeglad-instalacji-elektrycznej/",
  ELECTRICAL_MEASUREMENTS: "/pomiary-elektryczne/",
  LIGHTNING_CHECK: "/przeglad-instalacji-odgromowej/",
  PV_INSTALLATION_INSPECTION: "/przeglad-instalacji-fotowoltaicznej/",
  ENERGY_STORAGE_INSPECTION: "/przeglad-magazynu-energii/",
  SWITCHBOARD_INSPECTION: "/rozdzielnia-elektryczna/",

  // Gazowe
  GAS_CHECK: "/przeglad-instalacji-gazowej/",
  GAS_TIGHTNESS_TEST: "/proba-szczelnosci-gazu/",
  GAS_BOILER: "/przeglad-kotla-gazowego/",
  GAS_INSTALLATION_ACCEPTANCE: "/odbior-instalacji-gazowej/",

  // Inne
  FIRE_DETECTION_INSPECTION: "/przeglad-systemow-wykrywania-pozaru/",
  FIRE_EQUIPMENT_INSPECTION: "/przeglad-sprzetu-przeciwpozarowego/",
  EVACUATION_FIRE_PROTECTION_INSPECTION:
    "/przeglad-zabezpieczen-ewakuacyjnych-i-przeciwpozarowych/",

  // Kominowe i wentylacyjne
  CHIMNEY: "/przeglad-kominiarski/",
  VENTILATION: "/przeglad-wentylacji/",
  AIR_CONDITIONING: "/przeglad-klimatyzacji/",
  HEAT_PUMP: "/przeglad-pompy-ciepla/",

  // Budowlane
  BUILDING_INSPECTION: "/przeglad-budowlany/",

  PROPERTY_MANAGERS: "/przeglady-dla-zarzadcow-nieruchomosci/",
  LANDLORDS: "/przeglady-dla-wlascicieli-mieszkan/",
  BUILDING_MANAGERS: "/przeglady-dla-administratorow-budynkow/",
  HOMEOWNERS: "/przeglady-dla-wlascicieli-domow/",
  REAL_ESTATE: "/przeglady-dla-biur-nieruchomosci/",

  BLOG: "/poradnik/",
  CITIES: "/miasta/",
  FAQ: "/faq/",
  ABOUT_US: "/o-nas/",
  PRIVACY_POLICY: "/polityka-prywatnosci/",
  LEGISLATION: "/legislacja/",
  CONTACT_US: "/kontakt/",
  BOOK_NOW: "/zarezerwuj-przeglad/",
  SOLUTIONS: "/rozwiazania/",
};
